(() => {
 const selector='a[href],button,summary,[role="button"],input:not([type="hidden"]),textarea,select,label[for]';
 const identify=element=>{
   if(!element||element.disabled||element.getAttribute('aria-disabled')==='true')return null;
   const style=getComputedStyle(element);
   if(['Top','Right','Bottom','Left'].some(side=>parseFloat(style['border'+side+'Width'])>0&&style['border'+side+'Style']!=='none')||style.boxShadow!=='none')element.classList.add('seronine-has-frame');
   return element;
 };
 const releaseTimers=new WeakMap();
 const mark=event=>identify(event.target.closest?.(selector));
 document.addEventListener('pointerover',mark,{passive:true});
 document.addEventListener('focusin',mark);
 document.addEventListener('pointerdown',event=>{const element=mark(event);if(element){clearTimeout(releaseTimers.get(element));element.classList.add('seronine-pressed');}}, {passive:true});
 const release=()=>document.querySelectorAll('.seronine-pressed').forEach(element=>{clearTimeout(releaseTimers.get(element));releaseTimers.set(element,setTimeout(()=>element.classList.remove('seronine-pressed'),element.matches('.seronine-dawn-desktop-pf-card-20260830__link')?500:220));});
 document.addEventListener('pointerup',release,{passive:true});
 document.addEventListener('pointercancel',release,{passive:true});
 window.addEventListener('blur',release);
})();
window.addEventListener('pageshow',()=>document.querySelectorAll('.seronine-pressed').forEach(e=>e.classList.remove('seronine-pressed')));
/* Mobile zoom returns only when the page returns to its original top position. */
(() => {
 const sync=()=>document.documentElement.classList.toggle('seronine-pdp-scrolled',window.scrollY>4);
 window.addEventListener('scroll',sync,{passive:true});
 window.addEventListener('pageshow',sync);
 sync();
})();
